import { z } from 'zod'
import interceptedAxios from '../../../../utils/interceptedAxios'

const ZApiResponse = z.object({
  http_status: z.number(),
  data: z.array(z.string()).nullable(),
  error: z.boolean(),
  error_message: z.optional(z.string())
})
export type FilterParameter = z.infer<typeof ZApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function getUsersParameter (
  onSuccess: (FilterParameter: ApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/app-config-service/api/v1/crypto/users'
  interceptedAxios
    .get(url)
    .then((response) => {
      // istanbul ignore else
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        // istanbul ignore else
        if (parseResponse.success) {
          const parsedData: ApiResponse = parseResponse.data
          if (parsedData.data == null) {
            onFailure('Missing filter data', response.status)
          } else {
            onSuccess(parsedData, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      onFailure(error.message, error.status)
    })
}
